import React from 'react';
import YachtCardHeader from '../YachtCardHeader';
import YachtCardBaseInfo from '../YachtCardBaseInfo';
import { Button, Dialog } from 'day8-ui';
import { RxCross1 } from "@react-icons/all-files/rx/RxCross1";
import { useYachtModal } from '../../context/YachtModalContext';

const SanitisedYachtModal = () => {
  const { yachtData, close } = useYachtModal();
  if (!yachtData) {
    return 'loading';
  }

  const {
    title, description, years, bathrooms, maxCapacity, maxCapacityTooltipText, length, hasAircon, images, crew, week, packageData, cabinCrew, hullType, suitablePackageIds
  } = yachtData;

  return (
    <Dialog open onOpenChange={close} scrollable title={<div className='dui-flex dui-justify-end'><Button buttonType="LINK" onClick={close}><RxCross1/></Button></div>}>
      <YachtCardHeader
        title={title}
        description={description}
        years={years}
        bathrooms={bathrooms}
        maxCapacity={maxCapacity}
        maxCapacityTooltipText={maxCapacityTooltipText}
        length={length}
        hasAircon={hasAircon}
        crew={crew}
        week={week}
        packageData={packageData}
        cabinCrew={cabinCrew}
        hullType={hullType}
        suitablePackageIds={suitablePackageIds}
      />
      {images?.length > 0 && (
        <div className="dui-mt-4">
          <YachtCardBaseInfo images={images} alt={title} />
        </div>
      )}
    </Dialog>
  );
};

export default SanitisedYachtModal;
